import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { Merchant } from '../../../models/merchant/merchant';
import { FloatLabelType } from '@angular/material/form-field';
import { StreetAddressComponent } from '../../street-address/street-address.component';
import { MerchantService } from '../../../models/merchant/merchantService';
import { StreetAddress } from '../../../models/streetAddress/streetAddress';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { TextInputComponent } from '../../ui/controls/text-input/text-input.component';
import { DdlInputComponent } from '../../ui/controls/ddl-input/ddl-input.component';
import { iValidatedControl } from '../../ui/controls/iValidatedControl';
import {
  FormValidator,
  ValidationMessage,
} from '../../../models/validation/formValidator';
import { UIHelpers } from '../../../core/ui-helpers';
import { FormMode } from '../../../core/constants';
import { BaseComponent } from '../../baseComponent';
import { CacheService } from '../../../core/storage/cacheService';
import { Logging } from '../../../core/logging';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'merchant-billing-info',
  templateUrl: './merchant-billing-info.component.html',
  standalone: false,
})
export class BillingInformationComponent extends BaseComponent {
  @Input() merchant: Merchant | undefined; //Partial<Merchant> = Merchant.createEmpty();
  @Input() enableEditing: boolean = false;
  @Input() mode: FormMode = FormMode.View;
  @Input() enableDataStore: boolean = false;
  @Output() saved = new EventEmitter<boolean>();

  @ViewChild(StreetAddressComponent) billingAddressForm:
    | StreetAddressComponent
    | undefined;
  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  data: Merchant; // = Merchant.createEmpty();

  accountHolderOptions: ListItem[] = CacheService.bankHolderTypesList;
  accountTypeOptions: ListItem[] = CacheService.bankAccountTypesList;

  constructor(
    public merchantService: MerchantService,
    private uiErrorHandler: UIErrorHandler,
    private formValidator: FormValidator,
  ) {
    super();

    this.data = Merchant.createEmpty();
  }

  ngOnInit() {
    if (this.merchant && this.data) {
      this.data.id = this.merchant.id;
      this.copyModelData(this.merchant, this.data);
    }
  }

  public validate(): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    let validatedControls: iValidatedControl[] = [];
    if (this.validatedTextBoxes && this.validatedDropDowns) {
      validatedControls = validatedControls.concat(
        this.validatedTextBoxes.toArray(),
      );
      validatedControls = validatedControls.concat(
        this.validatedDropDowns.toArray(),
      );

      errors = this.formValidator.validate(validatedControls);
    }

    if (this.billingAddressForm) {
      errors = errors.concat(this.billingAddressForm.validate());
    }

    return errors;
  }

  public getData(merchantData: Merchant) {
    if (this.data) {
      merchantData.billingAccountHolderType =
        this.data.billingAccountHolderType;
      merchantData.billingAccountNum = this.data.billingAccountNum;
      merchantData.billingAccountType = this.data.billingAccountType;
      merchantData.billingName = this.data.billingName;
      merchantData.billingRoutingNum = this.data.billingRoutingNum;
      merchantData.billingAddress = this.data.billingAddress;
    }
  }

  private copyModelData(source: Merchant, destination: Partial<Merchant>) {
    destination.billingAccountNum = source.billingAccountNum;
    destination.billingRoutingNum = source.billingRoutingNum;
    destination.billingAccountHolderType = source.billingAccountHolderType;
    destination.billingAccountType = source.billingAccountType;

    if (source.billingAddress) {
      destination.billingAddress = StreetAddress.clone(source.billingAddress);
    } else {
      destination.billingAddress = StreetAddress.createEmpty();
    }
  }

  public btnEdit_click() {
    if (this.merchant && this.data) {
      this.copyModelData(this.merchant, this.data);
      this.mode = FormMode.Edit;
    }
  }

  public btnSaveClick() {
    var that = this;

    if (this.data) {
      this.data.billingAddress =
        this.billingAddressForm?.getStreetAddress() ||
        StreetAddress.createEmpty();

      this.merchantService
        .patchMerchantBillingInfo(this.data)
        .then((savedMerchant) => {
          if (that.data && that.merchant) {
            this.copyModelData(that.data, that.merchant);
            //this.copyModelData(savedMerchant, that.data);

            that.mode = FormMode.View;
            UIHelpers.scrollToTopIfOffPage('billingInformationContainer');

            this.saved.emit(true);
          }
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }

  public btnCancelClick() {
    if (this.merchant && this.data) {
      this.copyModelData(this.merchant, this.data);
      this.mode = FormMode.View;
      UIHelpers.scrollToTopIfOffPage('billingInformationContainer');
    }

    this.saved.emit(false);
  }

  getFloatLabelValue(): FloatLabelType {
    return 'auto';
  }
}
